import wrap from "./wrap-root-element"

export const wrapRootElement = wrap;